import React, { createContext, ReactNode, useContext } from 'react'
import { useParams } from 'react-router-dom'

// Creates the context object that we'll pass into components
export const ShipmentIdContext = createContext<string>('')

/**
 * Provide default Provider state component to wrap around app
 */
export const ShipmentIdProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { shipmentId } = useParams<{
    shipmentId: string
  }>()

  return <ShipmentIdContext.Provider value={shipmentId}>{children}</ShipmentIdContext.Provider>
}

export const useShipmentIdContext = () => useContext(ShipmentIdContext)
